import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { SnackbarProvider } from "notistack";
import { InnerSnackbarUtilsConfigurator } from "Utils/snackBarUtil";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Button, Modal } from "react-bootstrap";
import DownloadAppButton from "Common/Modals/DownloadAppModal";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
export let setErrorRef: any;
export let errorRef: any;

root.render(
  <React.Fragment>
    <SnackbarProvider
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <InnerSnackbarUtilsConfigurator />
      <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
          {/* <DownloadAppButton /> */}
        <DownloadAppButton/>
        </BrowserRouter>
      </Provider>
    </SnackbarProvider>
  </React.Fragment>
);

// serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
